<template>
<div class="mTab">
    <router-link class="box" :class="[$route.name=='ApplyIndex'?'selected':'']" :to="{name: 'ApplyIndex'}">
        <div class="icon icon-aa-index"></div>
        <div class="name">首页</div>
    </router-link>
    <router-link class="box" :class="[$route.name=='MyIndex'?'selected':'']" :to="{name: 'MyIndex'}">
        <div class="icon icon-aa-my"></div>
        <div class="name">我的</div>
    </router-link>
</div>
</template>

<script>
export default {
    name: 'mTab',
    data() {
        return {}
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mTab {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0.88rem;
    background: $c-white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 0.01rem solid $line;
    font-size: 0.22rem;
    .box{
        color: $c-black;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
        .icon{
            width: 0.4rem;
            height: 0.4rem;
        }
        .name{
            line-height: 0.3rem;
        }
    }
    .selected{
        color: $c-blue;
    }
}
</style>